import React from "react";
import cx from "classnames";
import { PencilIcon } from "assets";
import { useTranslation } from "i18n";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import { dataTestIds } from "data-testids";

interface Props {
  onClick?: () => void;
  editToPath?: string;
  editToClick?: () => void;
  className?: string;
  iconClassName?: string;
  ariaLabel?: string;
}

const EditButton = ({
  onClick,
  editToPath,
  editToClick,
  className,
  iconClassName,
  ariaLabel,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ProfileButton
      onClick={onClick}
      to={editToPath}
      toClick={editToClick}
      className={cx("h-8 w-8 min-w-8 rounded-full", className)}
      data-testid={`${dataTestIds.profile["Profile.EditButton"]}`}
      aria-label={ariaLabel || t("common:aria.label.edit")}
    >
      <PencilIcon
        width={16}
        height={16}
        className={iconClassName}
        aria-hidden="true"
        focusable="false"
      />
    </ProfileButton>
  );
};

export default EditButton;
